// Products-per-row preference: sets data-mobile / data-desktop so grid utilities restyle without re-rendering.
const STORAGE_KEY = 'collection-grid-columns';
const ALLOWED = { mobile: ['2', '3'], desktop: ['3', '4'] };

class SGridColumns extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const saved = this.#read();
    for (const scope of Object.keys(ALLOWED)) {
      if (ALLOWED[scope].includes(saved[scope])) this.dataset[scope] = saved[scope];
    }

    this.addEventListener(
      'command',
      (event) => {
        if (event.command !== '--columns' || !(event.source instanceof HTMLElement)) return;
        const { scope, columns } = event.source.dataset;
        if (!ALLOWED[scope]?.includes(columns)) return;
        this.dataset[scope] = columns;
        this.#write();
        this.#sync();
      },
      { signal: this.#controller.signal }
    );

    this.#sync();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #sync() {
    for (const button of this.querySelectorAll('[command="--columns"]')) {
      const pressed = this.dataset[button.dataset.scope] === button.dataset.columns;
      button.setAttribute('aria-pressed', String(pressed));
    }
  }

  #read() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch {
      return {};
    }
  }

  #write() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ mobile: this.dataset.mobile, desktop: this.dataset.desktop }));
    } catch {
      // Storage can be unavailable in private modes; the choice still applies for this page view.
    }
  }
}

customElements.define('s-grid-columns', SGridColumns);
